import { Button, ButtonProps, Space, Typography } from "antd";
import { PropsWithChildren } from "react";
import { TbAlertCircle } from "react-icons/tb";

interface SectionErrorRootProps extends PropsWithChildren {
  className?: string;
}

interface SectionErrorTextProps extends PropsWithChildren {
  className?: string;
  icon?: boolean;
}

interface SectionErrorButtonProps extends ButtonProps {}

const Root = ({ children, className }: SectionErrorRootProps) => {
  return <div className={`flex flex-col gap-4 items-center justify-center ${className ?? ""}`}>{children}</div>;
};

const Text = ({ children, className, icon = true }: SectionErrorTextProps) => {
  return (
    <Space align="start">
      {icon === true && <TbAlertCircle size={20} className="stroke-red-500" />}

      <Typography.Paragraph
        type="danger"
        style={{ margin: 0 }}
        className={`max-w-[600px] text-center ${className ?? ""}`}
      >
        {children}
      </Typography.Paragraph>
    </Space>
  );
};

const ActionButton = ({ children, ...props }: SectionErrorButtonProps) => {
  return <Button {...props}>{children}</Button>;
};

export const SectionError = Object.assign(Root, {
  Text,
  Button: ActionButton,
});
